/** Shared contact endpoints for CTAs (email, optional phone). */
export const OLIVEUP_HELLO_EMAIL = "hello@getoliveup.com";

export const OLIVEUP_MAILTO = `mailto:${OLIVEUP_HELLO_EMAIL}?subject=${encodeURIComponent(
  "Question about business funding"
)}`;

export const OLIVEUP_BUSINESS_HOURS = "Mon–Fri, 8a–8p ET • Sat by appointment";

/** Mon–Fri 08:00–20:00 America/New_York (live chat window). Sat/Sun = off. */
export function isOliveUpLiveChatHours(now = new Date()) {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: "America/New_York",
    weekday: "short",
    hour: "numeric",
    minute: "numeric",
    hour12: false,
  }).formatToParts(now);

  const wd = parts.find((p) => p.type === "weekday")?.value ?? "";
  const hour = Number(parts.find((p) => p.type === "hour")?.value ?? NaN);
  const minute = Number(parts.find((p) => p.type === "minute")?.value ?? NaN);
  if (!Number.isFinite(hour) || !Number.isFinite(minute)) return true;

  const weekdayShort = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const dayIndex = weekdayShort.indexOf(wd);
  if (dayIndex === 0 || dayIndex === 6) return false;

  const minutes = hour * 60 + minute;
  return minutes >= 8 * 60 && minutes < 20 * 60;
}

/**
 * When you publish a main line, set E.164 (e.g. +15551234567) to show Call / Text
 * in the header and footer. Leave empty to hide those CTAs.
 */
export const OLIVEUP_PHONE_E164 = "";
